<template>

    <div>
        <b-form-group id="igFullName">
            <b-form-input id="fullName"
                          name="fullName"
                          placeholder="Jméno a příjmení *"
                          v-model="dataInput"
                          :state.sync="validInput"
                          v-on:keyup="inputTextChange"
                          aria-describedby="fullNameFeedback"></b-form-input>
            <b-form-invalid-feedback id="fullNameFeedback">Musíte vyplnit jméno a příjmení.</b-form-invalid-feedback>
        </b-form-group>
    </div>

</template>

<script>

    export default {
        name: 'fullNameFormInput',
        data: function () {
            return {
                localModel: this.model,
                localValid: this.valid
            }
        },
        props: {
            model: {
            },
            valid: {
            }
        },
        computed: {
            dataInput: {
                get: function () {
                    return this.model;
                },
                set: function (newValue) {
                    this.localModel = newValue
                }
            },
            validInput: {
                get: function () {
                    return this.valid;
                },
                set: function (newValue) {
                    this.localValid = newValue
                }
            }
        },
        mounted() {
        },
        methods: {
            inputTextChange() {
                this.$emit('update:model', this.localModel);
            }
        }
    }

</script>